module.exports = __webpack_public_path__ + "img/banner_mistral.e159024.jpg";